import {
  AssetDetailsFormStep,
  StaticFieldToDisplayType,
} from "#src/batteries-included-components/Panels/FormPanels/AssetDetailsFormPanel/AssetDetailsFormStep";
import { useListCustomAttributes } from "#src/components/hooks/adapters/useCustomAttributes";
import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import {
  AssetType,
  AttributeDataType,
  DeviceSchemaEnumKeys,
  DeviceTypeType,
  Resources,
} from "@validereinc/domain";
import { Devices } from "@validereinc/domain-controllers";

import { useListMeasurementTypes } from "#src/components/hooks/adapters/useMeasurementTypes";
import React from "react";

const { DeviceStatusOptions } = Devices.view;

export const DeviceDetailsFormStep = ({
  deviceTypes,
}: {
  deviceTypes: DeviceTypeType[];
}) => {
  const { getStep } = useMultiStepFormContext();
  const prevStep = getStep(1);
  const prevStepValues = prevStep?.getValues();

  const { data: measurementTypes, isLoading: isLoadingMeasurementTypes } =
    useListMeasurementTypes();

  const { data: customAttributesData, isLoading: isLoadingCustomAttributes } =
    useListCustomAttributes({
      filters: { entity_type: AssetType.DEVICE },
    });
  const customAttributes = customAttributesData?.data ?? [];

  const selectedDeviceTypeId = prevStepValues?.[DeviceSchemaEnumKeys.type_id];
  const selectedDeviceType = deviceTypes?.find(
    (deviceType) => deviceType.id === selectedDeviceTypeId
  );

  const staticFieldsToDisplay: StaticFieldToDisplayType[] = [
    {
      display_name: "Status",
      field_name: DeviceSchemaEnumKeys.status,
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: DeviceStatusOptions.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      is_required: true,
    },
    {
      display_name: "Valid Measurement Types",
      field_name: DeviceSchemaEnumKeys.measurement_types,
      data_type: AttributeDataType.MULTI_PICK_LIST,
      pick_list_values: measurementTypes?.map((option) => ({
        id: option.id,
        name: option.name,
      })),
      is_required: true,
    },

    ...(selectedDeviceType
      ? (selectedDeviceType?.attributes?.map((attribute) => {
          return {
            ...attribute,
            field_name: `attributes.${attribute.id}`,
            display_name: attribute.name,
          };
        }) ?? [])
      : []),
    ...customAttributes.map((custom_attribute) => {
      return {
        ...custom_attribute,
        field_name: `custom_attributes.${custom_attribute.field_name}`,
      } as typeof custom_attribute;
    }),
  ].sort((a, b) => Number(b.is_required) - Number(a.is_required));

  const isLoading = isLoadingMeasurementTypes || isLoadingCustomAttributes;

  return (
    <AssetDetailsFormStep
      resourceType={Resources.DEVICE}
      staticFieldsToDisplay={staticFieldsToDisplay}
      isLoadingFields={isLoading}
    />
  );
};
